import React, { FC } from "react";
import { FieldsSize, FromThirdStepData } from "../../Helpers/interfaces";
import { CloseButton } from "../../CloseButton/CloseButton";
import { Input } from "../Input/Input";
import { useForm, UseFormSetValue } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useLabels } from "../../Hooks/useLabels";
import { PhoneNumberValidator } from "../../Validation/PhoneNumberValidator";
import { LoadingAnimation } from "../../../LoadingAnimation/LoadingAnimation";
import ClickAwayListener from "react-click-away-listener";
import { useHandleClickAway } from "../../Hooks/useHandleClickAway";
import classNames from "classnames";

type PhoneNumberModalFormType = {
  mobileNumber: number;
};

type PhoneConfirmationModalProps = {
  createMetodikaBooking: (bookingRequest: FromThirdStepData) => void;
  onClose: () => void;
  isOpen: boolean;
  getFormData: () => FromThirdStepData;
  setValue: UseFormSetValue<FromThirdStepData>;
  heading: string;
  inputLabel: string;
  intro: string;
  buttonLabel: string;
  loading: boolean;
  Modal: any;
};
export const PhoneConfirmationModal: FC<PhoneConfirmationModalProps> = ({
  onClose,
  isOpen,
  getFormData,
  heading,
  inputLabel,
  intro,
  buttonLabel,
  setValue,
  loading,
  Modal,
  createMetodikaBooking,
}) => {
  const { bookingLabels } = useLabels();
  const {
    handleMouseUp,
    handleMouseDown,
    handleClickAway,
    areaRef,
  } = useHandleClickAway(onClose);

  const {
    handleSubmit,
    getValues,
    formState: { errors },
    register,
  } = useForm<PhoneNumberModalFormType>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: { mobileNumber: getFormData().mobileNumber },
    resolver: yupResolver(PhoneNumberValidator(bookingLabels!.bookingErrors)),
  });

  const createBooking = async ({ mobileNumber }: PhoneNumberModalFormType) => {
    setValue("mobileNumber", mobileNumber);
    createMetodikaBooking(getFormData());
  };

  return (
    <Modal
      bodyOpenClassName={"ReactModal__Body--open"}
      overlayClassName="react-modal__overlay"
      className={classNames("react-modal__content react-modal__content--additional", { 'react-modal__content--opened': isOpen })}
      isOpen={isOpen}
      shouldCloseOnEsc
      onRequestClose={onClose}
    >
      <div className="confirm-modal__outer">
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className="confirm-modal__inner my-2 p-2 pt-1 fs-5" ref={areaRef} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}>
            <CloseButton onClick={onClose} withWhiteBg />
            <h4>{heading}</h4>
            <div
              dangerouslySetInnerHTML={{
                __html: intro,
              }}
            />
            <form onSubmit={handleSubmit(createBooking)}>
              <div className="mt-4">
                <div className="d-sm-flex">
                  <div className="w-100 pe-sm-1">
                    <Input
                      name="mobileNumber"
                      label={inputLabel}
                      inputmode={"tel"}
                      type="tel"
                      size={FieldsSize.fullWidth}
                      getValues={getValues}
                      error={errors.mobileNumber}
                      register={register}
                      reversedColors
                    />
                  </div>
                  <div className="w-100 ps-sm-1">
                    <button
                      className="btn btn-primary booking-narrow-item w-100 mt-2"
                      type="submit"
                      disabled={!!errors.mobileNumber}
                    >
                      {loading ? (
                        <LoadingAnimation text={buttonLabel} />
                      ) : (
                        buttonLabel
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </ClickAwayListener>
      </div>
    </Modal>
  );
};
